// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class IActivateCardRequestModel {
    static getAttributeTypeMap() {
        return IActivateCardRequestModel.attributeTypeMap;
    }
}
IActivateCardRequestModel.discriminator = undefined;
IActivateCardRequestModel.additionalProperties = false;
IActivateCardRequestModel.attributeTypeMap = [
    {
        "name": "programId",
        "baseName": "programId",
        "type": "number"
    },
    {
        "name": "memberNumber",
        "baseName": "memberNumber",
        "type": "string"
    },
];
//# sourceMappingURL=iActivateCardRequestModel.js.map